import React, { Component } from "react";
import style from "./DashboradCount.module.css";
import todaysAppointmentIc from "../../assets/images/dashboard/todays-appointments-blue.svg";
import outofstockSuppliesIc from "../../assets/images/dashboard/out-of-stock-supplies-blue.svg";
import totalConductedAppointmentsIc from "../../assets/images/dashboard/total-conducted-appointments-blue.svg";
import totalInvoicesIc from "../../assets/images/dashboard/total-invoices-blue.svg";
import totalPaymentTransactionsIc from "../../assets/images/dashboard/total-payment-transactions-blue.svg";
import totalProductsIc from "../../assets/images/dashboard/total-products-blue.svg";
import totalRelatedPartiesIc from "../../assets/images/dashboard/total-related-parties-blue.svg";
import totalScheduledPaymentsIc from "../../assets/images/dashboard/total-scheduled-payments-blue.svg";
import totalUsersIc from "../../assets/images/dashboard/total-users-blue.svg";
import waitingPatientIc from "../../assets/images/waiting-patients.svg";
import activePatientsIc from "../../assets/images/active-patients.svg";
import pendingApprovalIc from "../../assets/images/pending-approval.svg";
import outstandingInvoicesIc from "../../assets/images/outstanding-invoices.svg";
import reminderNotesIc from "../../assets/images/reminder-notes.svg";
import LabelsData from "../../utils/DashboardCountLabels.json";
import { Link } from "react-router-dom";
import { Permissions, checkIfPermitted } from "../../services/RolePermissionService";

export class DashboradCount extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userRole:""
    };
  }

  componentDidMount(){
    let userInfo = JSON.parse(localStorage.getItem("USER_INFO"));
    if(userInfo && userInfo.systemRole){
      // let role = userInfo.role.toUpperCase();
      // role = role.replace(" ", "_");
     // console.log("role", userInfo.systemRole)
     let userRoleArray=[1,2,3,4,5];
     (userRoleArray.indexOf(Number(userInfo.systemRole))!=-1)?  this.setState({userRole: userInfo.systemRole}):this.setState({userRole:3})
    }
  }

  getImageURL = (key) =>{
    switch (key) {
      case "appointmentCount":
        return todaysAppointmentIc;
        break;
    
      case "outOfStock":
        return outofstockSuppliesIc;
        break;

      case "waitingPatientCount":
        return waitingPatientIc;
        break;
    
      case "conductAppointmentCount":
        return totalConductedAppointmentsIc;
        break;
  
      case "invoiceCount":
        return totalInvoicesIc;
        break;

      case "paymentCount":
        return totalPaymentTransactionsIc;
        break;

      case "stockCheckCount":
        return totalProductsIc;
        break;

      case "relatedPartyCount":
        return totalRelatedPartiesIc;
        break;
    
      case "schedulePaymentCount":
        return totalScheduledPaymentsIc;
        break;
    
      case "usersCount":
        return totalUsersIc;
        break;
      
      case "outstandingInvoices":
       return totalInvoicesIc;
       break;
       case "pastAppointmentCount":
       return totalConductedAppointmentsIc;
       break;
      default:
      return "";
        break;
    }
  }

  getValidCounts = (data) => {
      if(data){
        return data;
      }else{
        return 0;
      }
  }

  render() {
    const dashboardCountData = this.props.dashboardCounts;

    if(dashboardCountData && dashboardCountData.length === 0){
      return null;
    }

    return (
      <div className={style.countPostionWrapper}>
        <ul className={`row ${style.countMainWrapper}`}>
          {LabelsData && LabelsData[this.state.userRole] && LabelsData[this.state.userRole].map((element, index)=>(
            <li key={index} className="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl ">
            <Link to={(element.permissionKey && checkIfPermitted(Permissions[element.permissionKey])) || !element.permissionKey ? {
              pathname: element.link?element.link:"/app/dashboard",
              params: element.props
              }:"/app/dashboard"}>
              <div className={style.countInnerWrapper}>
                <div className={style.heading}>{this.getValidCounts(dashboardCountData[element.key])}</div>
                <div
                  className={`d-flex align-items-center justify-content-center ${style.iconWrapper} dashboard-list-box`}
                >
                  <img src={this.getImageURL(element.key)} alt={element.key} />
                  <p>{element.label}</p>
                </div>
              </div>
            </Link>
          </li>
          ))}
        </ul>
      </div>
    );
  }
}

export default DashboradCount;
